
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-ps/pegawai/pelaksanaan/praktik-kinerja/pendampingan-satuan-pendidikan",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-ps/pegawai/pelaksanaan/praktik-kinerja/pendampingan-satuan-pendidikan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-ps/pegawai/pelaksanaan/praktik-kinerja/pendampingan-satuan-pendidikan"])
      });
    }
  